import { useMemo } from 'react';
import { useDeviceDetect } from 'hooks';

export default () => {
  const { isMobile } = useDeviceDetect();
  const constrains = useMemo(() => (isMobile ? { height: 480, frameRate: 24, width: 640 } : { height: 720, frameRate: 24, width: 1280 }), [isMobile]);
  return constrains;
};
